import fetch from '@/utils/fetch';
import { message } from 'antd';

const model = {
  state: {
    page_size: 10,
    // order
    list: [],
    total: 0,
    listLoading: false,
    exportLoading: false,
    subShops: [],
    //  恒通财务列表
    htList: [],
    htTotal: 0,
    //  平安财务列表
    pingList: [],
    pingTotal: 0,
    // 充值查询列表
    chargeSearchList: [],
    chargeSearchTotal: 0,
    // 充值报表列表
    chargeSheetList: [],
    chargeSheetTotal: 0,
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { finance, basic }, getState }) => ({
    // 设置备注
    async setRemark(params) {
      const data = await fetch('/saasmerchant/web/statement/setRemark', {
        type: 'POST',
        params: { ...params, billId: params.bill_id },
      });
      return data;
    },
    //  获取恒通财务报表
    async getHtPolyList(params) {
      finance.setState({ listLoading: true });
      const { union_shop_id } = getState().basic;
      const { page_size } = getState().finance;
      const newParams = {
        union_shop_id,
        page_size,
        ...params,
      };
      newParams.start_time = newParams.start_time.unix();
      newParams.end_time = newParams.end_time.unix();
      const data = await fetch('/merchant/fsdata/htfzlist', { params: newParams });
      if (data) {
        finance.setState({
          htList: data.list,
          htTotal: data.count,
        });
      }
      finance.setState({ listLoading: false });
    },
    //  获取平安财务报表
    async getPingPolyList(params) {
      finance.setState({ listLoading: true });
      const { union_shop_id } = getState().basic;
      const { page_size } = getState().finance;
      const newParams = {
        unionShopId: union_shop_id,
        pageSize: page_size,
        shopId: params.shop_id,
        subShopId: params.sub_shop_id || 0,
        freightStatus: params.freight_status,
        orderId: params.order_id,
        ...params,
      };
      newParams.startTime = newParams.start_time.unix();
      newParams.endTime = newParams.end_time.unix();
      delete newParams.shop_id;
      delete newParams.freight_status;
      delete newParams.sub_shop_id;
      delete newParams.order_id;
      delete newParams.start_time;
      delete newParams.end_time;
      const data = await fetch('/saasmerchant/web/statement/pingfzlist', { params: newParams });
      if (data) {
        finance.setState({
          pingList: data.list,
          pingTotal: data.total,
        });
      }
      finance.setState({ listLoading: false });
    },
    //  导出恒通商户财务报表
    async exportHtList(params) {
      finance.setState({ exportLoading: true });
      const { union_shop_id } = getState().basic;
      const { page_size } = getState().finance;
      const newParams = {
        union_shop_id,
        page_size,
        export: 1,
        ...params,
      };
      newParams.start_time = newParams.start_time.unix();
      newParams.end_time = newParams.end_time.unix();
      const data = await fetch('/merchant/fsdata/htfzlist', { params: newParams });

      finance.setState({ exportLoading: false });
      return data;
    },
    // 获取企业充值记录列表
    async getChargeLogList(params) {
      const data = await fetch('/saasmerchant/fsarea/charge/record/page', {
        params: {
          ...params,
        },
      });
      if (data) {
        finance.setState({
          chargeSearchList: data.list,
          chargeSearchTotal: data.total,
        });
      }

      return data;
    },
    // 企业充值查询-撤回
    async recallSubmit(params) {
      const data = await fetch('/saasmerchant/fsarea/charge/cancel', {
        type: 'POST',
        params,
      });
      return data;
    },
    // 充值记录导出
    async exporChargeLogList(params) {
      const data = await fetch('/saasmerchant/fsarea/charge/record/download', {
        params: {
          ...params,
          startDate: params.startDate,
          endDate: params.endDate,
        },
      });
      if (data) {
        data.status && message.success('成功添加导出任务');
        basic.setLogListDot(true);
      }
    },

    // 获取企业充值报表列表
    async getChargeSheetList(params) {
      const data = await fetch('/saasmerchant/fsarea/charge/record/monthly/page', {
        params: {
          ...params,
        },
      });
      if (data) {
        finance.setState({
          chargeSheetList: data.list,
          chargeSheetTotal: data.total,
        });
      }

      return data;
    },
    // 充值报表导出
    async exporChargeSheetList(params) {
      const data = await fetch('/saasmerchant/fsarea/charge/record/monthly/download', {
        params: {
          month: params,
        },
      });
      if (data) {
        data.status && message.success('成功添加导出任务');
        basic.setLogListDot(true);
      }
    },
    // 重置充值记录表格
    initChargeSearchList() {
      finance.setState({
        chargeSearchList: [],
        chargeSearchTotal: 0,
      });
    },
    // 重置充值报表表格
    initChargeSheetList() {
      finance.setState({
        chargeSheetList: [],
        chargeSheetTotal: 0,
      });
    },
  }),
};

export default model;
